export default {
      id: "oc-mongodb-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-mongodb",
      toString: function () {
        return this.url;
      }
    }